export const DATA_PATH = `${process.env.PUBLIC_URL}/data.json`;
